import { ConfigurationResponse, SDModules } from '../../models/configuration';
import { configurationSignal } from '../../store/StoreContext';
import API_CALL from '../API';

export class ConfigurationService {
  private static instance: ConfigurationService;

  private constructor() {}

  public static getInstance(): ConfigurationService {
    if (!ConfigurationService.instance) {
      ConfigurationService.instance = new ConfigurationService();
    }
    return ConfigurationService.instance;
  }

  public async getConfiguration(): Promise<ConfigurationResponse> {
    try {
      return await API_CALL({
        url: '/user/configuration',
        method: 'GET',
      }).then((configuration) => {
        configurationSignal.value = configuration;
        return configuration;
      });
    } catch (err) {
      console.error('Configuration fetch failed', err);
      throw err;
    }
  }

  public async updateConfiguration(
    config: Partial<ConfigurationResponse>
  ): Promise<ConfigurationResponse> {
    try {
      return await API_CALL({
        url: '/user/configuration',
        method: 'PUT',
        data: config,
      }).then((configuration) => {
        configurationSignal.value = configuration;
        return configuration;
      });
    } catch (err) {
      console.error('Configuration update failed', err);
      throw err;
    }
  }

  private getModule(moduleName: SDModules) {
    return configurationSignal.value?.[moduleName];
  }

  public isModuleEnabled(moduleName: SDModules) {
    if (moduleName === 'DesktopClient') return true;
    const enabled = this.getModule(moduleName)?.enabled;
    return !!enabled;
  }
}

// Esporta un'istanza singleton del servizio
export const configurationService = ConfigurationService.getInstance();
